import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import { SearchInput } from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'
import React, { useEffect, useState } from 'react'

const LocationFilterQuest = ({ collegeList, college, setCollege }) => {
  const [updatedList, setUpdatedList] = useState([])
  const [filteredLocations, setFilteredLocations] = useState([])
  const [searchInput, setSearchInput] = useState('')

  useEffect(() => {
    setUpdatedList(collegeList || [])
  }, [collegeList])

  const handleSearchInput = e => {
    const searchTerm = e?.target?.value?.toLowerCase()
    setSearchInput(searchTerm)

    const filteredCities = updatedList?.filter(option =>
      option?.permCity?.toLowerCase()?.includes(searchTerm)
    )

    setFilteredLocations(filteredCities)
  }

  return (
    <Wrapper column>
      <SearchInput
        placeholder="Search by location"
        bordered={true}
        onChange={handleSearchInput}
        width={'450px'}
      />
      <FilterCheckBoxComp
        onChange={values => setCollege([values[values?.length - 1]])}
        value={college}
        options={searchInput ? filteredLocations : updatedList}
        valueParam="permCity"
        labelParam="permCity"
      />
    </Wrapper>
  )
}

export default LocationFilterQuest
